// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle-" + "7646e5243d3d1b3a5d37" + ".digested.css";
};